document.addEventListener('DOMContentLoaded', () => {
  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink?.querySelector('span');
  const nonFullImg = document.getElementById('nonfull_img');

  lastTabLink?.classList.add('inactive');
  lastTabSpan?.classList.add('inactive');
  if (nonFullImg) nonFullImg.style.display = 'none';
});

function fullCourse() {
  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink?.querySelector('span');
  const firstTabLink = document.querySelector('ul.course_tab_nav > li:first-child > a.realtab');
  const firstTabSpan = firstTabLink?.querySelector('span');

  lastTabLink?.classList.add('inactive');
  lastTabSpan?.classList.add('inactive');
  firstTabLink?.classList.remove('inactive');
  firstTabSpan?.classList.remove('inactive');

  const fullImg = document.getElementById('full_img');
  const nonFullImg = document.getElementById('nonfull_img');
  const highLowWrap = document.querySelector('.high_low_wrap');
  const courseWrap = document.querySelector('.course_wrap');

  if (fullImg) fullImg.style.display = 'block';
  if (nonFullImg) nonFullImg.style.display = 'none';
  if (highLowWrap) highLowWrap.style.display = 'block';
  if (courseWrap) courseWrap.style.marginBottom = '60px';
}

function kmCourse() {
  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink?.querySelector('span');
  const firstTabLink = document.querySelector('ul.course_tab_nav > li:first-child > a.realtab');
  const firstTabSpan = firstTabLink?.querySelector('span');

  lastTabLink?.classList.remove('inactive');
  lastTabSpan?.classList.remove('inactive');
  firstTabLink?.classList.add('inactive');
  firstTabSpan?.classList.add('inactive');

  const fullImg = document.getElementById('full_img');
  const nonFullImg = document.getElementById('nonfull_img');
  const highLowWrap = document.querySelector('.high_low_wrap');
  const courseWrap = document.querySelector('.course_wrap');

  if (fullImg) fullImg.style.display = 'none';
  if (nonFullImg) nonFullImg.style.display = 'block';
  if (highLowWrap) highLowWrap.style.display = 'none';
  if (courseWrap) courseWrap.style.marginBottom = '120px';
}

window.fullCourse = fullCourse;
window.kmCourse = kmCourse;
